<!--  -->
<template>
  <div class="">
    <div class="handsel-order-detail-time" v-if="showType === '1'" v-html="times"></div>
    <div class="time-down" v-else>
      请在 <span>{{ times }}</span
      >内完成{{ showTitle(handselInfo.status) }}支付，超时将自动{{handselInfo.status===1?'取消':'关闭'}}
    </div>
  </div>
</template>

<script>
import { timerCount } from '@/utils/tools';
// import moment from 'moment';

export default {
  components: {},
  data() {
    return {
      times: '',
    };
  },
  props: {
    handselInfo: {
      type: Object,
      default: () => {},
    },
    showType: {
      type: String,
      default: '0',
    },
  },
  computed: {},
  watch: {},
  methods: {
    checkTime() {
      const { _endTime, currentTime } = this.handselInfo;
      let temp = 0;
      const timeStamp = _endTime;
      if (timeStamp < currentTime) {
        this.updateInfo(1);
        return;
      }
      temp = timeStamp - currentTime + 2000;
      // eslint-disable-next-line no-undef

      this.showTime(timerCount(temp, 2));
      this.timers = setInterval(() => {
        temp -= 1000;
        if (temp > 0) {
          this.showTime(timerCount(temp, 2));
        } else {
          // 倒计时结束  重新拉取接口请求
          clearInterval(this.timers);
          this.updateInfo(1);
        }
      }, 1000);
    },
    showTime(times) {
      const {
        d, h, m, s,
      } = times;
      if (this.showType === '1') {
        const day = `${d !== '00' ? `${Number(d)}<span class='day'>天</span>` : ''}`;
        const hours = `${h !== '00' ? `${Number(h)}<span>小时</span>` : ''}`;
        const mins = `${Number(m)}<span>分</span>`;
        const sec = `${Number(s)}<span>秒</span>`;
        const name = `<span>剩余</span>${day}${hours}${mins}${sec}<span>自动关闭</span>`;
        this.times = name;
      } else {
        const day = `${d !== '00' ? `${Number(d)}天` : ''}`;
        const hours = `${h !== '00' ? `${Number(h)}小时` : ''}`;
        const name = `${day}${hours}${m}分${s}秒`;
        this.times = name;
      }
    },
    showTitle(status) {
      let name = '';
      switch (status) {
        case 1:
          name = '定金';
          break;
        case 4:
          name = '尾款';
        // eslint-disable-next-line no-fallthrough
        default:
      }
      return name;
    },
    updateInfo(status) {
      this.$emit('updateInfo', { status, handselInfo: this.handselInfo });
    },
  },
  created() {},
  mounted() {
    this.checkTime();
  },
};
</script>
<style lang="scss" scoped>
.time-down {
  color: #787878;
  font-weight: 400;
  font-size: 22px;
  line-height: 28px;
  span {
    color: #ff6c02;
    font-weight: normal;
    font-size: 22px;
    letter-spacing: 2px;
  }
}

</style>
